(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            var resolver = {
                resolve : $routeProvider.ResolverFactory.moduleIsActivated("loyaltycard").resolver
            };

            $routeProvider
                .when('/loyaltycard', {
                    templateUrl: require('../templates/loyalty-list.html'),
                    resolve: resolver
                })
                .when('/loyaltycard/:info', {
                    templateUrl: require('../templates/loyalty-card.html'),
                    resolve: resolver
                });
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/loyalty/routes/loyalty-routes.js